<template>
  <div class="Melamine">
    <div class="title">N-Butyl Acetate</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item" width="300">
        </el-table-column>
        <el-table-column prop="Index" label="Index" width="300">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>180kg/drum, 14.4mt/20'FCL, 25.2mt/40'FCL.</p>
    </div>
    <div class="item-huanhang">
      <label>Used</label>
      <p>
        Used as solvent in coating, paint, varnish, printing, ink, adhesive,
        leather oil, nitrocellulose, etc it's also applied to prepare perfume,
        in pharmaceutical industry, it'sused as extractant.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Item: "Appearance",
          Index: "Colorless transparent liquid",
        },
        {
          Item: "Purity, %≥",
          Index: "99.7",
        },
        {
          Item: "Moisture, %≤",
          Index: "0.04",
        },
        {
          Item: "Color, (Pt-Co)≤",
          Index: "10",
        },
        {
          Item: "Specific Gravity (20°C)",
          Index: "0.878-0.883",
        },
        {
          Item: "Acidity(as Acetic acid), %≤",
          Index: "0.004",
        },
        {
          Item: "n-Butyl alcohol, % ≤",
          Index: "0.05",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
